import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import MaterialFormPage from "./pages/MaterialFormPage/MaterialFormPage";
import MaterialLoginPage from "./pages/MaterialLoginPage/MaterialLoginPage";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import MaterialTablePage from "./pages/MaterialTablePage/MaterialTablePage";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import ServiceLoginPage from "./pages/ServiceLoginPage/ServiceLoginPage";
import ServiceFormPage from "./pages/ServiceFormPage/ServiceFormPage";
import ServiceTablePage from "./pages/ServiceTablePage/ServiceTablePage";
import LasServiceFormPage from "./pages/LasServiceFormPage/ServiceFormPage";
import LasServiceTablePage from "./pages/LasServiceTablePage/ServiceTablePage";
import LasServiceLoginPage from "./pages/LasServiceLoginPage/ServiceLoginPage";
import LasMaterialTablePage from "./pages/LasMaterialTablePage/LasMaterialTablePage";
import LasMaterialFormPage from "./pages/LasMaterialFormPage/LasMaterialFormPage";
import LasMaterialLoginPage from "./pages/LasMaterialLoginPage/LasMaterialLoginPage";
import DashboardPage from "./pages/DashboardPage/DashboardPage";

export default function AppRouter() {
  return (
    <Router>
      <Switch>
        <PublicRoute
          path="/dashboard"
          component={DashboardPage}
        />

        <PublicRoute
          path="/loginMaterial/:hash"
          component={MaterialLoginPage}
        />

        <PrivateRoute path="/materialContract/material">
          <MaterialFormPage />
        </PrivateRoute>

        <PrivateRoute path="/materialContract">
          <MaterialTablePage />
        </PrivateRoute>

        <PublicRoute path="/loginService/:hash" component={ServiceLoginPage} />

        <PrivateRoute path="/serviceContract/service">
          <ServiceFormPage />
        </PrivateRoute>

        <PrivateRoute path="/ServiceContract">
          <ServiceTablePage />
        </PrivateRoute>

        <PublicRoute
          path="/loginLasService/:hash"
          component={LasServiceLoginPage}
        />

        <PrivateRoute path="/lasServiceContract/lasService">
          <LasServiceFormPage />
        </PrivateRoute>

        <PrivateRoute path="/lasServiceContract">
          <LasServiceTablePage />
        </PrivateRoute>

        <PublicRoute
          path="/loginLasMaterial/:hash"
          component={LasMaterialLoginPage}
        />

        <PrivateRoute path="/lasMaterialContract/lasMaterial">
          <LasMaterialFormPage />
        </PrivateRoute>

        <PrivateRoute path="/lasMaterialContract">
          <LasMaterialTablePage />
        </PrivateRoute>

        <Route component={NotFoundPage} />
      </Switch>
    </Router>
  );
}
